
export enum StorageKeys {
    AppSettings = "appSettings",
    //AppState = "eLynxAppState",
    UserSettings = "eLynxUserSettings",
    UserState = 'eLynxUserState',
    LastCustomerID = "eLynxLastCustomerID",
    LastCustomerName = "eLynxLastCustomerName",
    LastUserName = "eLynxLastUserName",
    RememberUser = "eLynxRememberUser",
    IsSSO = "eLynxSSO",
    RedirectRestorePath = "eLynxRestorePath",
    ImpersonatingGlobalLoginID = "impersonatingGlobalLoginID",
    ImpersonatorUserID = "impersonatorUserID",
    ImpersonatorUserLogin = "impersonatorUserLogin",
    PendingExports = "pendingExports"
}